/* eslint-disable import/prefer-default-export */
import { first } from 'lodash';
import * as Sentry from '@sentry/react';

import { errorHandlerActions } from 'store/slices/errorHandlerSlice';

const isCommonGraphQLError = (error) => {
  const errorMessage = error.message || '';
  if (errorMessage.includes('GraphQL Error')) {
    return true;
  }

  return false;
};

export const handleError =
  ({ error, heading }) =>
  (dispatch) => {
    Sentry.withScope((scope) => {
      const requestId = first(error.response?.errors)?.extensions?.requestId;
      /* istanbul ignore if */
      if (requestId) {
        scope.setTag('requestId', requestId);
      }
      Sentry.captureException(error);
    });

    const defaultMessage = 'Something went wrong. Please try again.';

    const firstError = first(error.response?.errors);
    const errorExtensions = firstError?.extensions || error.response?.extensions;
    const i18nCode = errorExtensions?.i18nCode;
    const errorCode = errorExtensions?.code;
    const errorData = errorExtensions?.errorData;

    if (isCommonGraphQLError(error)) {
      dispatch(
        errorHandlerActions.setError({
          error: {
            errorHeader: heading || 'Error',
            message: defaultMessage,
            stack: error.stack,
            i18nCode,
            code: errorCode,
            errorData,
          },
        })
      );
      return;
    }

    dispatch(
      errorHandlerActions.setError({
        error: {
          errorHeader: heading || 'Error',
          message:
            /* istanbul ignore next */ error.response?.message ||
            firstError?.message ||
            error.message,
          stack: error.stack,
          i18nCode,
          code: errorCode,
          errorData,
        },
      })
    );
  };
